<template>
  <div class="quotes-page">
    <Page title="All Quotes" max-width="850">
      <p class="text-center">
        Review or request service from {{ tenant.name }} for the following
        quotes by selecting the Proceed with Service option.
      </p>
      <Datatable
        class="quotes-table"
        :headers="headers"
        :report-path="'/reports/consumer/quotes.json'"
        :sort-by="'id'"
        :sort-desc="true"
      >
        <template #item.name="{ item }">
          <div
            class="quote-cell quote-name"
            :title="item.name || 'Untitled Quote'"
          >
            {{ item.name || "Untitled Quote" }}
          </div>
        </template>
        <template #item.summary="{ item }">
          <v-tooltip location="top" max-width="320" :disabled="!summaryTooltip[item.id]">
            <template #activator="{ props: tooltipProps }">
              <div
                class="quote-cell quote-summary"
                v-bind="tooltipProps"
                @mouseenter="(event) => handleSummaryMouseenter(item.id, event)"
              >
                {{ decodeHtml(item.summary) }}
              </div>
            </template>
            <span>{{ decodeHtml(item.summary) || "No description available" }}</span>
          </v-tooltip>
        </template>
        <template #item.actions="{ item }">
          <div class="d-flex justify-end align-center">
            <div class="d-flex">
              <a href="" @click.prevent="toggleProceedModal(item)">
                Proceed with Service
              </a>
              <v-divider vertical class="mx-3"></v-divider>
            </div>
            <router-link
              :to="{ name: 'quotePreview', params: { id: item.id } }"
            >
              View Quote
            </router-link>
          </div>
        </template>
      </Datatable>
    </Page>
    <quote-proceed-modal
      v-if="proceedModal"
      :quote="selectedQuote"
      @hide-modal="toggleProceedModal"
      @save-success="toggleProceedSuccess"
    ></quote-proceed-modal>
    <success-toast v-if="proceedSuccess" @hide-modal="toggleProceedSuccess">
      <template #body>
        <div>
          <p>Your request for service has been successfully submitted.</p>
        </div>
      </template>
    </success-toast>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Datatable from "@/components/Datatable.vue";
import Page from "@/components/Page.vue";
import QuoteProceedModal from "@/components/QuoteProceedModal.vue";
import SuccessToast from "@/components/SuccessToast.vue";

export default {
  components: {
    Page,
    QuoteProceedModal,
    SuccessToast,
    Datatable
  },
  data() {
    return {
      proceedModal: false,
      selectedQuote: null,
      proceedSuccess: false,
      summaryTooltip: {},
      headers: [
        { text: "Date", value: "date" },
        { text: "Name", value: "name" },
        { text: "Description", value: "summary" },
        { text: "Quote #", value: "id" },
        { text: "Job #", value: "job_id" },
        { text: "Total", value: "total", align: "end" },
        { text: "", value: "actions", sortable: false }
      ]
    };
  },
  computed: {
    ...mapState({
      user: "user",
      tenant: "tenant"
    })
  },
  methods: {
    toggleProceedModal(quote) {
      this.selectedQuote = quote;
      this.proceedModal = !this.proceedModal;
    },
    toggleProceedSuccess() {
      this.proceedSuccess = !this.proceedSuccess;
    },
    handleSummaryMouseenter(id, event) {
      const shouldShow = this.isTextTruncated(event.currentTarget);
      this.summaryTooltip[id] = shouldShow;
    },
    isTextTruncated(el) {
      if (!el) return false;
      return (
        el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.quotes-page {
  :deep(.datatable td) {
    white-space: normal;
    height: auto !important;
    vertical-align: top;
  }

  .quote-cell {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    line-height: 1.3;
  }

  .quote-name {
    -webkit-line-clamp: 2;
    font-weight: 600;
    max-width: 220px;
  }

  .quote-summary {
    -webkit-line-clamp: 3;
    max-width: 280px;
  }

  @media (max-width: 600px) {
    .quote-name {
      max-width: 180px;
    }

    .quote-summary {
      max-width: 220px;
    }
  }
}

.v-tooltip__content {
  background-color: #0b0f17 !important;
  color: #fff !important;
}
</style>
